import React from "react";
import {
  IconWrapper,
} from "./styles";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";

const VisibilityIcons = ({ ...props }) => {
  return (
    <IconWrapper>
      {props.isVisible ? (
        <VisibilityIcon
          onClick={() =>
            props.setShowPassword({
              ...props.showPassword,
              [props.typePassword]: !props.isVisible,
            })
          }
          style={{ color: '#1b2c58', cursor: 'pointer' }}
        />
      ) : (
        <VisibilityOffIcon
          onClick={() =>
            props.setShowPassword({
              ...props.showPassword,
              [props.typePassword]: !props.isVisible,
            })
          }
          style={{ color: '#1b2c58', cursor: 'pointer' }}
        />
      )}
    </IconWrapper>
  );
};
export default VisibilityIcons;
